export function formatTableValues(item) {
    if (!item) {
        return;
    }
    if (typeof item === "boolean") {
        if (item) return "Sim";
        return "Não";
    } else if (
        regexDate.test(item) ||
        regexDateWithHour.test(item)
    ) {
        return moment(item).format("DD/MM/YYYY");
    } else if (item.length > 50) {
        return item.substring(0, 100) + "...";
    }

    return item;
}

const regexDate = /^\d{4}[\-\/\s]?((((0[13578])|(1[02]))[\-\/\s]?(([0-2][0-9])|(3[01])))|(((0[469])|(11))[\-\/\s]?(([0-2][0-9])|(30)))|(02[\-\/\s]?[0-2][0-9]))$/
const regexDateWithHour = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/